import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/UnicommerceIntegration/UnicommerceHome';

const UnicommerceHome = () => ((orgContainer(InnerComponent)));
export default UnicommerceHome;
